module.exports = __webpack_public_path__ + "img/wode_denglu_but.4301f36c.png";